<script lang="ts" setup>
import ThreadsNav from "@/components/mobile/ThreadsNav.vue";
import { onBeforeMount, ref, watch } from "vue";
import { Tab, Tabs } from "vant";
import ThreadList, {
  ThreadListInstance,
} from "@/components/mobile/ThreadList.vue";
import { useReviewer } from "@/stores/reviewer";

const currentTab = ref(0);
const reviewerStore = useReviewer();
const incomeListRef = ref<ThreadListInstance | null>(null);
const expenditureListRef = ref<ThreadListInstance | null>(null);

const refreshRecordsByTabIdx = async (idx: number) => {
  if (idx === 0) {
    reviewerStore.incomeList = [];
    incomeListRef.value?.resetScrollLoadingState();
  } else {
    reviewerStore.expenditureList = [];
    expenditureListRef.value?.resetScrollLoadingState();
  }
};
onBeforeMount(() => {
  refreshRecordsByTabIdx(currentTab.value);
});

watch(currentTab, (newVal) => {
  refreshRecordsByTabIdx(newVal);
});
const transferToCoinRecordItemProps = (item: any) => {
  return {
    id: item.id,
    title: item.title,
    coinAmount: item.coinAmount,
    type: item.type,
    createdAt: item.createdAt,
  };
};
</script>
<template>
  <div class="h-full grid grid-rows-[auto_1fr] relative">
    <threads-nav :enable-switch-mate="false" show-back>
      <template #center> {{ $t("Coin.coinRecords") }}</template>
    </threads-nav>
    <div class="overflow-hidden h-full">
      <tabs
        v-model:active="currentTab"
        class="h-full grid grid-rows-[auto_1fr] thread-tabs"
        swipeable
      >
        <tab :title="$t('Coin.incomeRecord')" class="overflow-y-auto">
          <thread-list
            ref="incomeListRef"
            :on-pull-load="reviewerStore.fetchNewerIncomeList"
            :on-scroll-load="reviewerStore.fetchOlderIncomeList"
            class="px-2"
          >
            <coin-record-item
              v-for="item in reviewerStore.incomeList"
              :key="item.id"
              :amount="item.amount"
              :time="item.dtCreate!"
              :title="item.title"
              :type="item.type"
            >
              <template #coin-icon>
                <i class="iconify mdi--ticket text-my-yellow text-sm" />
              </template>
            </coin-record-item>
          </thread-list>
        </tab>
        <tab :title="$t('Coin.expenditureRecord')" class="overflow-y-auto">
          <thread-list
            ref="expenditureListRef"
            :on-pull-load="reviewerStore.fetchNewerExpenditureList"
            :on-scroll-load="reviewerStore.fetchOlderExpenditureList"
            class="px-2"
          >
            <coin-record-item
              v-for="item in reviewerStore.expenditureList"
              :key="item.id"
              :amount="item.amount"
              :time="item.dtCreate"
              :title="item.title"
              :type="item.type"
            >
              <template #coin-icon>
                <i class="iconify mdi--ticket text-my-yellow text-sm" />
              </template>
            </coin-record-item>
          </thread-list>
        </tab>
      </tabs>
    </div>
  </div>
</template>
